import { Tag } from 'rsuite';

const SCTag = (props) => {
    return (
        <Tag {...props}>{props.children}</Tag>
    );
}

export default SCTag;